import { cached } from '@glimmer/tracking';

import type { DSData } from 'webapp-types';

import type DsDataOutputTopLevel from 'webapp/models-custom/ds-data/output/top';
import type DsDataPointCompare from 'webapp/models-custom/ds-data/point/compare';
import DsDataPointWithTs from 'webapp/models-custom/ds-data/point/with-ts';

export default class DsDataPointTopLevel extends DsDataPointWithTs {
	output: DsDataOutputTopLevel;

	incomplete: boolean;
	extra: DSData.AnomalyExtraData | DSData.GoalPointExtraData | null;

	constructor(output: DsDataOutputTopLevel, rawData: DSData.PointTopLevel) {
		super(rawData);
		this.output = output;
		this.ts = rawData.ts;
		this.incomplete = !!rawData.incomplete;
		this.extra = rawData.extra || null;
	}

	@cached
	get comparePoints() {
		const comparePoints: DsDataPointCompare[] = [];
		this.output.compareOutputs.forEach((compareOutput) => {
			const comparePoint = compareOutput.getPointForIndex(this.index);
			if (comparePoint) {
				comparePoints.push(comparePoint);
			}
		});
		return comparePoints;
	}
}
